export function mappingQueryParams(params) {
  if (params && typeof params === "object" && Object.keys(params)) {
    let queryStr = "?";

    Object.keys(params).forEach((prop) => {
      if (params[prop]) {
        const value = encodeURIComponent(params[prop]);

        if (queryStr.length > 1) {
          queryStr += `&${prop}=${value}`;
        } else {
          queryStr += `${prop}=${value}`;
        }
      }
    });

    return queryStr.length > 1 ? queryStr : "";
  }

  return "";
}
